import { List, ListItem, SwipeableDrawer } from '@mui/material'
import { useAuth } from 'context'
import { AppMenuItem } from './AppMenuItem'
import MenuLogo from './MenuLogo'
import { AppMenuSubMenuItem } from './AppMenuSubMenuItem'

interface AppMenuProps {
  isMenuOpen: boolean
  isMobile: boolean
  onCloseMenu: () => void
  onOpenMenu: () => void
}

const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)

export default function AppMenu({ isMenuOpen, isMobile, onOpenMenu, onCloseMenu }: AppMenuProps) {
  const { permissions } = useAuth()

  return (
    <SwipeableDrawer
      anchor={isMobile ? 'bottom' : 'left'}
      color='primary'
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
      disableSwipeToOpen={false}
      ModalProps={{ keepMounted: true }}
      onClose={onCloseMenu}
      onOpen={onOpenMenu}
      open={isMenuOpen}
      swipeAreaWidth={45 /*192*/}
      PaperProps={{
        sx: {
          backgroundColor: '#152B54',
          // width: '100%',
          // maxWidth: '320px',
          ...(isMobile
            ? {
                maxHeight: '80vh',
                overflowY: 'auto'
              }
            : {
                width: '250px',
                overflowX: 'hidden'
              })
        }
      }}
      /* To Do this should be in the theme... */
      sx={theme => ({ display: 'flex', width: '250px', zIndex: theme.zIndex.drawer })}
      variant={isMobile ? 'temporary' : 'permanent'}
    >
      <List
        component='div'
        disablePadding
        sx={{
          backgroundColor: '#152B54',
          backgroundImage: `url(${process.env.PUBLIC_URL + '/sidebar.png'})`,
          backgroundPosition: 'bottom center',
          backgroundRepeat: 'no-repeat',
          minHeight: '100%',
          overflowY: 'auto'
        }}
      >
        <ListItem sx={theme => ({ marginBottom: theme.spacing(2) })}>
          <MenuLogo src={process.env.PUBLIC_URL + '/logo-lg.png'} />
        </ListItem>

        <AppMenuItem onCloseMenu={onCloseMenu} to='/to-do-list'>
          To Do List
        </AppMenuItem>

        {permissions.ADMINISTRATION_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/reports'>
            Reports
          </AppMenuItem>
        )}

        {permissions.ADMINISTRATION_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/settings'>
            Settings
          </AppMenuItem>
        )}

        {(permissions.COMPANIES_AND_PEOPLE_ADD_EDIT || permissions.COMPANIES_AND_PEOPLE_READ_ONLY) && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/people'>
            People
          </AppMenuItem>
        )}

        {(permissions.COMPANIES_AND_PEOPLE_ADD_EDIT || permissions.COMPANIES_AND_PEOPLE_READ_ONLY) && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/companies'>
            Companies
          </AppMenuItem>
        )}

        {permissions.INBOUND_TRIPS_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/inbound-trips'>
            Inbound Trips
          </AppMenuItem>
        )}

        {permissions.OUTBOUND_TRIPS_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/outbound-trips'>
            Outbound Trips
          </AppMenuItem>
        )}

        {permissions.ADMINISTRATION_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/move-vehicle'>
            Move Vehicle
          </AppMenuItem>
        )}

        {permissions.TITLES_ADD_EDIT && (
          <AppMenuSubMenuItem
            title='Titles'
            onCloseMenu={onCloseMenu}
            items={[
              { to: '/michigan-titles', label: 'Michigan Titles' },
              { to: '/titles/michigan-sos-bundles', label: 'Michigan SoS Bundles' },
              { to: '/michigan-outgoing-titles', label: 'Michigan Outgoing Titles' },
              { to: '/titles/ohio-titles', label: 'Ohio Titles' },
              { to: '/titles/ohio-build-a-boxes', label: 'Build A Box (Ohio)' },
              { to: '/ohio-outgoing-titles', label: 'Ohio Outgoing Titles' }
            ]}
          />
        )}

        {permissions.OCR_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/ocr'>
            OCR
          </AppMenuItem>
        )}

        {permissions.CLUSTERS_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/cluster-shippers'>
            Cluster Shippers
          </AppMenuItem>
        )}

        {permissions.CONFORMITY_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/conformity'>
            Conformity
          </AppMenuItem>
        )}

        {permissions.DAMAGE_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/damage'>
            Damage
          </AppMenuItem>
        )}

        {permissions.INVOICES_ADD_EDIT && (
          <AppMenuItem onCloseMenu={onCloseMenu} to='/invoicing'>
            Invoicing
          </AppMenuItem>
        )}
      </List>
    </SwipeableDrawer>
  )
}
